import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { StoredImage } from '../models/stored-image';

// Images enregistrées en base par l'API (envoi réservé aux membres connectés, JWT)
@Injectable({
  providedIn: 'root'
})
export class ImagesService {

  private host = environment.host + '/images';

  constructor(private httpClient: HttpClient) { }

  upload(file: File): Observable<StoredImage> {
    const body = new FormData();
    body.append('file', file, file.name);
    return this.httpClient.post<StoredImage>(this.host, body);
  }

  // L'API télécharge l'image (referer : page de l'offre, pour les sites qui bloquent le hotlink)
  importFromUrl(url: string, referer?: string): Observable<StoredImage> {
    return this.httpClient.post<StoredImage>(this.host + '/import', { url, referer });
  }
}
